module.exports = __webpack_public_path__ + "static/img/03.131d3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/03.png
// module id = oq86
// module chunks = 1